const _getCategories = () => {
    const gradeNames = [
        'پیش‌دبستانی',
        'پایه اول',
        'پایه دوم',
        'پایه سوم',
        'پایه چهارم',
        'پایه پنجم',
        'پایه ششم',
        'پایه هفتم',
        'پایه هشتم',
        'پایه نهم',
    ];
    const categoriesSize = gradeNames.map((name, index) => ({
        id: index + 1,
        name,
        size: '1600x1600',
    }));
    return categoriesSize;
}

export { _getCategories }
